import React, { useState, useEffect } from "react";
import * as Style from "../../styledComponents/PersonalInstruction";

export const PermissionsSection = ({
  formData,
  handleSubmit,
  handlechange,
  loading
}) => {
  const [originalHideTransactions, setOriginalHideTransactions] = useState(false);
  const showApplyButton = formData && formData.hideTransactions !== originalHideTransactions;
  
  console.log("originalHideTransactions",originalHideTransactions,showApplyButton,formData)
  const handleCheckboxChange = (e) => {
    setOriginalHideTransactions(!originalHideTransactions)
    handlechange("hideTransactions", e.target.checked);

  };

  const handleApplyPermissions = (e) => {
    e.preventDefault();

    // You might want to call handleSubmit here if it applies
    // setOriginalHideTransactions(formData && formData.hideTransaction);
    setOriginalHideTransactions(!originalHideTransactions)
    handleSubmit(e);
  };

  return (
    <div className="permissionsSection">
      <h1 className="MainProfileHeading">Permissions & Visibility</h1>

      <div style={{ marginTop: "2rem" }}>
        <p className="permissionSubHeading">Manage Advisor Access</p>

        <div className="permissionBox">
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              color: "#2A3DA3",
            }}
          >
            <input
              type="checkbox"
              disabled={loading ? true : false}
              id="hideTransactions"
              checked={formData && formData.hideTransactions}
              onChange={handleCheckboxChange}
              className="customCheckbox"
            />
            <div>
              <label htmlFor="hideTransactions" className="checkboxLabel">
                Hide Bank Transactions from Advisor
              </label>
              <p className="checkboxPara">
                Hide Transactions and Recurring activity from your Advisor for
                added privacy.
              </p>
            </div>
          </div>
        </div>
      </div>

      {originalHideTransactions && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "24rem",
          }}
        >
          <Style.SaveButton1 onClick={handleApplyPermissions}>
            Apply Permissions
          </Style.SaveButton1>
        </div>
      )}
    </div>
  );
};
